import { render, staticRenderFns } from "./CommonSelecter.vue?vue&type=template&id=b8539d46&scoped=true&"
import script from "./CommonSelecter.vue?vue&type=script&lang=js&"
export * from "./CommonSelecter.vue?vue&type=script&lang=js&"
import style0 from "./CommonSelecter.vue?vue&type=style&index=0&id=b8539d46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8539d46",
  null
  
)

export default component.exports